import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useId } from 'react';
const ShadcnMarkdown = ({ formrValue, onUpdate, readonly = false }) => {
    // Ties the label to its control, so the field has an accessible name.
    const id = useId();
    const isDisabled = readonly || !formrValue.editable(formrValue.value);
    const [localValue, setLocalValue] = useState(formrValue.value ?? '');
    useEffect(() => {
        setLocalValue(formrValue.value ?? '');
    }, [formrValue.value]);
    const onChange = (event) => {
        const rawValue = event.target.value;
        setLocalValue(rawValue);
        onUpdate(formrValue.key, formrValue.setter(rawValue));
    };
    return (_jsxs("div", { className: "space-y-1", children: [_jsx("label", { htmlFor: id, className: "text-sm font-medium text-foreground", children: formrValue.label }), _jsx("textarea", { id: id, className: "flex min-h-24 w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-xs placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50", value: localValue, onChange: onChange, disabled: isDisabled })] }));
};
export { ShadcnMarkdown };
//# sourceMappingURL=ShadcnMarkdown.js.map